import React, { useEffect, useId, useRef } from 'react';
import licenseService from '../../../services/licenseService';
import { buildPaymentPayload } from 'utils/buildPaymentPayload';

const splitCustomerName = (fullName) => {
  const trimmed = fullName.trim();
  if (!trimmed) return ['', ''];
  const [firstName, ...rest] = trimmed.split(/\s+/);
  return [firstName, rest.join(' ') || firstName];
};

const CardCheckoutPanel = ({
  sdk,
  amount,
  license,
  accountEmail,
  customerName,
  customerCpf,
  onPaymentResult,
  onError,
}) => {
  const containerId = useId().replace(/:/g, '');
  const brickControllerRef = useRef(null);

  useEffect(() => {
    if (!sdk || !amount || !accountEmail) return undefined;

    let cancelled = false;
    const [firstName, lastName] = splitCustomerName(customerName);

    const mountBrick = async () => {
      try {
        const bricksBuilder = sdk.bricks();
        const controller = await bricksBuilder.create('cardPayment', containerId, {
          initialization: {
            amount: Number(amount),
            payer: {
              email: accountEmail,
              firstName,
              lastName,
              identification: {
                type: 'CPF',
                number: customerCpf,
              },
            },
          },
          callbacks: {
            onReady: () => {},
            onSubmit: async (cardFormData) => {
              const payload = buildPaymentPayload({
                paymentType: 'CREDIT_CARD',
                license,
                customerName,
                customerCpf,
              });

              payload.card = {
                token: cardFormData.token,
                payment_method_id: cardFormData.payment_method_id,
                installments: cardFormData.installments,
                issuer_id: cardFormData.issuer_id,
              };

              const response = await licenseService.generatePaymentOrder(payload);
              if (!response?.success) {
                throw new Error(response?.error || 'Erro ao processar pagamento com cartão');
              }

              onPaymentResult(response);
            },
            onError: (error) => {
              onError(error?.message || 'Erro no formulário de cartão');
            },
          },
        });

        if (!cancelled) {
          brickControllerRef.current = controller;
        } else {
          controller?.unmount?.();
        }
      } catch (error) {
        if (!cancelled) {
          onError(error.message || 'Não foi possível carregar o formulário de cartão');
        }
      }
    };

    mountBrick();

    return () => {
      cancelled = true;
      brickControllerRef.current?.unmount?.();
      brickControllerRef.current = null;
    };
  }, [
    sdk,
    amount,
    accountEmail,
    customerName,
    customerCpf,
    license,
    containerId,
    onPaymentResult,
    onError,
  ]);

  return (
    <div className="space-y-3">
      <p className="text-xs text-muted-foreground">
        Preencha os dados do cartão abaixo. O pagamento é processado com segurança pelo Mercado Pago.
      </p>
      <div id={containerId} />
    </div>
  );
};

export default CardCheckoutPanel;
